<template>
    <div class="TcInscriptionSending inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-xl w-full px-5">
        <div class="py-10">
            <div class="flex flex-col items-center">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-orange-400 text-white">
                    <svg class="h-10 w-10 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                    </svg>
                </div>
                <p class="mt-10 text-3xl text-center">Su solicitud está siendo procesada.</p>
                <p class="mt-5 text-3xl text-center">Por favor espere.</p>
                <button @click="$root.logOut(true)" class="btn-secondary mt-12">Cerrar sesión</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TcInscriptionSending',
  data () {
    return {}
  }
}
</script>